export enum TeamRole {
  ADMIN = "admin",
  READ = "read",
  WRITE = "write"
}

export const ORDERED_TEAM_ROLES = [
  TeamRole.ADMIN,
  TeamRole.WRITE,
  TeamRole.READ
] as const

export function isTeamRole(role: string | null | undefined): role is TeamRole {
  return Object.values(TeamRole).includes(role as TeamRole)
}
